import {SEARCH_CORRELATION_ID_HEADER} from 'search/SearchConstants';
import * as net from 'util/Net';

export function postSearchRequest({
  url,
  data,
  untracked,
}: {
  url: string;
  data?: object;
  untracked?: boolean;
  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
}): Promise<any> {
  // oxlint-disable-next-line @typescript-eslint/no-explicit-any
  const promise = new Promise<any>((resolve, reject) => {
    net
      .postJSON({url, data, untracked})
      .done((_data, _status, xhr) => {
        const searchResponseWithCorrelationId = {
          ..._data,
          correlationId: xhr.getResponseHeader(SEARCH_CORRELATION_ID_HEADER),
        };
        resolve(searchResponseWithCorrelationId);
      })
      .fail((e) => {
        reject(e);
      });
  });

  return promise;
}
